import { apiClient } from '../client';
import { City, Area, Currency } from '../../../contract/interfaces';
import { ApiResponse } from '../../../contract/types';
// Define query parameters interfaces
export interface CityQueryParams {
  id?: number;
  name?: string;
  country_id?: number;
  sort?: string;
  size?: number;
  page?: number;
}

export interface AreaQueryParams {
  id?: number;
  name?: string;
  city_id?: number;
  sort?: string;
  size?: number;
  page?: number;
}

export interface CurrencyQueryParams {
  id?: number;
  currency?: string;

}

// Get cities with query parameters
export const getCities = async (params?: CityQueryParams): Promise<ApiResponse<City[]>> => {
  const response = await apiClient.get('/corporate/v1/lookup/city', {
    params
  });

  // Extract total count from headers
  const total = parseInt(response.headers['x-total-count'] || '0', 10);

  return {
    data: response.data,
    total,
  };
};

// Get areas with query parameters
export const getAreas = async (params?: AreaQueryParams): Promise<ApiResponse<Area[]>> => {
  const response = await apiClient.get('/corporate/v1/lookup/area', {
    params
  });

  // Extract total count from headers
  const total = parseInt(response.headers['x-total-count'] || '0', 10);
  return {
    data: response.data,
    total,
  };
};

// Get currencies with query parameters
export const getCurrencies = async (params?: CurrencyQueryParams): Promise<ApiResponse<Currency[]>> => {
  const response = await apiClient.get('/catalog/lookup/currencies', {
    params
  });

  // Extract total count from headers
  const total = parseInt(response.headers['x-total-count'] || '0', 10);
  return {
    data: response.data,
    total,
  };
};


export const getCategories = async (params?: { storefront_id?: number ,tenant_id: number,component_id?:number}): Promise<ApiResponse<any[]>> => {
  const response = await apiClient.get("/corporate/v1/product/filter", {
    params,
  });
  const total = parseInt(response.headers["x-Result-count"] || "0", 10);
  return {
    data: response.data?.categories,
    total,
  };
};

export const getTenantFilters = async (params?: {tenant_id?: number,storefront_id?:number,component_id?: number}): Promise<ApiResponse<{brands: any[], categories: any[]}>> => {
  const response = await apiClient.get('/corporate/v1/tenant-products/filter', {
    params
  });
  
  const total = parseInt(response.headers['x-Result-count'] || '0', 10);
  return {
    data: response.data,
    total,
  };
};